import { useAlertsParams } from "app/pages/activation-alerts/hooks/useAlertsParams";
import { useAlertsSubscriptionsStatusQuery } from "app/pages/activation-alerts/queries/alerts/useAlertsSubscriptionsStatusQuery";

import { useSubscribeToAllAlertsMutation } from "../../queries/alerts/useSubscribeToAllAlertsMutation";

export const useSubscribeButton = () => {
    const { activationId } = useAlertsParams();

    const { data: subscriptionStatus, isLoading } = useAlertsSubscriptionsStatusQuery(activationId);
    const isSubscribed = Boolean(subscriptionStatus);

    const { mutate: subscribeToAlerts, isPending: isSubscribing } = useSubscribeToAllAlertsMutation({
        subscribeToBenchmark: false,
    });

    const subscribe = () => {
        subscribeToAlerts({ activationId });
    };

    const isButtonDisabled = isLoading || isSubscribing;

    return {
        activationId,
        isSubscribed,
        isButtonDisabled,
        subscribe,
    };
};
